import Vue from 'vue'
import VueRouter from 'vue-router'


// //测试
// import test from './components/template'

//中间页
import middlePage from './components/middlePage'
import { logoutApi} from "@/api/commonApi";

import VueCookies from 'vue-cookies'

//挂载路由
Vue.use(VueRouter)

// 修改路由push方法,阻止重复点击报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};

// 修改路由replace方法,阻止重复点击报错
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err);
};


//命名路由
const routes = [
    {
        path: '/wwx/auth-success',
        name: 'wwxAuthSuccess',
        component: r => require.ensure([], () => r(require('./components/wwxAuthSuccess.vue')), 'wwxAuthSuccess'),
    },
    {
    path: '/electron-login',
    name: 'electronLogin',
    component: r => require.ensure([], () => r(require('./page/common/electronLogin/login.vue')), 'electronLogin')
}, {
    path: '/public-login/:channel?/:client?',
    name: 'publicLogin',
    component: r => require.ensure([], () => r(require('./page/common/publicLogin/login.vue')), 'publicLogin')
}, {
    path: '/login',
    name: 'login',
    component: r => require.ensure([], () => r(require('./page/common/login/login.vue')), 'Login')
}, {
    path: '/jp-login',
    name: 'jpLogin',
    component: r => require.ensure([], () => r(require('./page/common/loginJp/login.vue')), 'jpLogin')
}, {
    path: '/register',
    name: 'register',
    component: r => require.ensure([], () => r(require('./page/activity/register/index')), 'Register'),
},
{
    path: '/register-login',
    name: 'register-login',
    component: r => require.ensure([], () => r(require('./page/activity/register_2/index')), 'Register'),
    // component: r => require.ensure([], () => r(require('./page/activity/register/index')), 'Register'),
},
{
    path: '/ground',
    name: 'ground',
    component: r => require.ensure([], () => r(require('./page/activity/ground/index')), 'Ground'),
}, {
    path: '/forget-password',
    name: 'forget-password',
    component: r => require.ensure([], () => r(require('./page/common/forgetPswJp/index.vue')), 'ForgetPassword'),
}, {
    path: '/',
    name: 'index',
    component: r => require.ensure([], () => r(require('./page/teacher/index/index.vue')), 'Index')
},
{
    path: '/student-index',
    name: 'student-index',
    // component: r => require.ensure([], () => r(require('./page/student/index/index.vue')), 'StudentIndex')
    component: r => require.ensure([], () => r(require('./page/student/index/index.vue')), 'StudentIndex')
},
{
    path: '/student-index/student-courses',
    name: 'student-index-student-courses',
    component: r => require.ensure([], () => r(require('./page/student/index/part/studentCourse.vue')), 'studentIndexCourse')
}, {
    path: '/prepare-course',
    name: 'prepare-course',
    component: r => require.ensure([], () => r(require('./page/teacher/prepareCourse/index.vue')), 'PrepareCourseIndex')
}, {
    path: '/pre-exam',
    name: 'pre-exam',
    component: r => require.ensure([], () => r(require('./page/teacher/preExam/index.vue')), 'preExamIndex')
}, {
    path: '/student-pre-exam',
    name: 'student-pre-exam',
    component: r => require.ensure([], () => r(require('./page/student/preExam/index.vue')), 'studentPreExamIndex')
}, {
    path: '/student-pre-exam/exam',
    name: 'student-pre-exam-exam',
    component: r => require.ensure([], () => r(require('./page/student/preExam/exam.vue')), 'studentPreExamExam')
}, {
    path: '/student-pre-exam/exam-preview',
    name: 'student-pre-exam-preview',
    component: r => require.ensure([], () => r(require('./page/student/preExam/examPreview.vue')), 'studentPreExamExamPreview')
}, {
    path: '/student-pre-exam/exam-report',
    name: 'student-pre-exam-report',
    component: r => require.ensure([], () => r(require('./page/student/preExam/report.vue')), 'studentPreExamExamReport')
},
{
    path: '/personal-center',
    name: 'personal-center',
    component: r => require.ensure([], () => r(require('./page/teacher/personalCenter/index/index.vue')), 'PersonalCenter'),
    children: [
        // {path:'',component:}
    ]
}, {
    path: '/m/personal-center',
    name: 'm-personal-center',
    component: r => require.ensure([], () => r(require('./page/teacher/personalCenter/mobile/index.vue')), 'mPersonalCenter'),
    children: [
        // {
        //     // 学习统计
        //     path: '/m/personal-center/class-manage',
        //     name: 'm-personal-center-class-manage',
        //     component: r => require.ensure([], () => r(require('./page/teacher/personalCenter/mobile/classMange.vue')), 'mClassmange'),
        // },
    ]
},
{
    path: '/m/personal-center/copy',
    name: 'm-personal-center-copy',
    component: r => require.ensure([], () => r(require('./page/teacher/personalCenter/mobile/part/copy_index.vue')), 'mCopy'),
},
{
    path: '/student-personal-center',
    name: 'student-personal-center',
    component: r => require.ensure([], () => r(require('./page/student/personalCenter/index/index.vue')), 'StudentPersonalCenter'),
    children: [
        // {path:'',component:}
    ]
},
{
    path: '/explore-problems',
    name: 'explore-problems',
    component: r => require.ensure([], () => r(require('./page/teacher/exploreProblems/index.vue')), 'exploreProblems'),

    children: [
        // {path:'',component:}
    ]
},
{
    path: '/teacher-course',
    name: 'teacher-course',
    component: r => require.ensure([], () => r(require('./page/teacher/teacherCourse/teacherCourse.vue')), 'TeacherCourse'),
    meta: {
        keepAlive: false // 需要被缓存
    }
}, {
    path: '/student-course',
    name: 'student-course',
    component: r => require.ensure([], () => r(require('./page/student/studentCourse/studentCourse.vue')), 'StudentCourse'),
    meta: {
        keepAlive: false // 需要被缓存
    }
}, {
    path: '/teacher-prepare-course',
    name: 'teacher-prepare-course',
    component: r => require.ensure([], () => r(require('./page/teacher/teacherCourse/teacherPrepareCourse.vue')), 'TeacherPrepareCourse'),
    meta: {
        keepAlive: false // 需要被缓存
    }
}, {
    path: '/course-exam',
    name: 'course-exam',
    component: r => require.ensure([], () => r(require('./page/teacher/courseExam/index.vue')), 'TeacherCourseExam'),
    meta: {
        keepAlive: false
    }
}, {
    path: '/answer-sheet',
    name: 'answer-sheet',
    component: r => require.ensure([], () => r(require('./page/teacher/answerSheet/index.vue')), 'TeacherAnswerSheet'),
    meta: {
        keepAlive: false
    }
}, {
    path: '/course-spoken-exam',
    name: 'course-spoken-exam',
    component: r => require.ensure([], () => r(require('./page/teacher/courseExam/spokenIndex.vue')), 'TeacherCourseSpokenExam'),
    meta: {
        keepAlive: false
    }
}, {
    path: '/course-push',
    name: 'course-push',
    component: r => require.ensure([], () => r(require('./page/teacher/coursePush/index.vue')), 'TeacherCoursePush'),
    meta: {
        keepAlive: false
    }
}, {
    path: '/course-share',
    name: 'course-share',
    component: r => require.ensure([], () => r(require('./page/teacher/courseShare/index.vue')), 'TeacherCourseShare'),
    meta: {
        keepAlive: false
    }
},
{
    path: '*',
    name: '404',
    component: r => require.ensure([], () => r(require('./page/common/notFound/notFound.vue')), 'NotFound'),
},
{
    path: '/academic-analysis',
    name: 'academic-analysis',
    component: r => require.ensure([], () => r(require('./page/teacher/academicAnalysis/index')), 'academicAnalysis'),
    redirect: '/academic-analysis/topic',
    children: [{
        // 学习统计
        path: '/academic-analysis/learning',
        name: 'academic-analysis-learning',
        component: r => require.ensure([], () => r(require('./page/teacher/academicAnalysis/part/learningStatistics')), 'learningStatistics'),
    }, {
        // 题目统计
        path: '/academic-analysis/topic',
        name: 'academic-analysis-topic',
        component: r => require.ensure([], () => r(require('./page/teacher/academicAnalysis/part/topicStatistics')), 'topicStatistics'),
    }, {
        //课堂问题
        path: '/academic-analysis/problem',
        name: 'academic-analysis-problem',
        component: r => require.ensure([], () => r(require('./page/teacher/academicAnalysis/part/classroomProblem')), 'classroomProblem'),
    },
        //     {
        //     //答题卡
        //     path: '/topic-static-answer-card',
        //     name: 'topic-static-answer-card',
        //     component: r => require.ensure([], () => r(require('./page/student/academicAnylysis/answerSheet/answerCard.vue')), 'newAnswerCard'),
        // }
    ]
},
{
    //补充解析
    path: '/exam-add-data',
    name: 'exam-add-data',
    component: r => require.ensure([], () => r(require('./components/examPreview/addData/addData')), 'addData'),
},
//学生学情分析
{
    path: '/academic-analysis-student',
    name: 'academic-analysis-student',
    component: r => require.ensure([], () => r(require('./page/student/academicAnylysis/index')), 'stuacademicAnalysis'),
    redirect: '/academic-analysis-student/topic',
    children: [{
        // 学习统计
        path: '/academic-analysis-student/learning',
        name: 'academic-analysis-student-learning',
        component: r => require.ensure([], () => r(require('./page/student/academicAnylysis/part/learningStatis')), 'stulearningStatistics'),
    }, {
        // 题目统计
        path: '/academic-analysis-student/topic',
        name: 'academic-analysis-student-topic',
        component: r => require.ensure([], () => r(require('./page/student/academicAnylysis/part/topicStatic')), 'stutopicStatistics'),
    }, {
        //课堂问题
        path: '/academic-analysis-student/problem',
        name: 'academic-analysis-student-problem',
        component: r => require.ensure([], () => r(require('./page/student/academicAnylysis/part/classroomProblem')), 'stuclassroomProblem'),
    }]
},
{
    //答题卡
    path: '/topic-static-answer-card',
    name: 'topic-static-answer-card',
    component: r => require.ensure([], () => r(require('./page/student/academicAnylysis/answerSheet/answerCard.vue')), 'newAnswerCard'),
},
//教师---学情统计
{
    path: '/topic-static',
    name: 'topic-static',
    component: r => require.ensure([], () => r(require('./page/teacher/academicAnalysisCommon/index.vue')), 'topicStatic'),
    redirect: '/topic-static/learning-analysis',
    children: [{
        // 学习统计
        path: '/topic-static/learning-analysis',
        name: 'topic-static-learning-analysis',
        component: r => require.ensure([], () => r(require('./page/teacher/academicAnalysisCommon/part/leaningAnlys')), 'commonLeaning'),
    }, {
        // 题目统计
        path: '/topic-static/wrong-static',
        name: 'topic-static-wrong-static',
        component: r => require.ensure([], () => r(require('./page/teacher/academicAnalysisCommon/part/wrongStatics')), 'commonWrongStatic'),
    }, {
        //课堂问题
        path: '/topic-static/resource-static',
        name: 'topic-static-resource-static',
        component: r => require.ensure([], () => r(require('./page/teacher/academicAnalysisCommon/part/resourceStatistics')), 'commonResourceStatic'),
    }]
},
{
    path: '/sso-register/:token',
    name: 'ssoRegister',
    component: r => require.ensure([], () => r(require('./page/teacher/register/index')), 'ssoRegister'),
},
{
    path: '/error',
    name: 'error',
    component: r => require.ensure([], () => r(require('./components/error.vue')), 'error'),
},
{
    path: '/test',
    name: 'test',
    component: r => require.ensure([], () => r(require('./components/template-1')), 'test'),
},
{
    path: '/test2',
    name: 'test2',
    component: r => require.ensure([], () => r(require('./components/template-2')), 'test'),
}, {
    path: '/test4',
    name: 'test4',
    component: r => require.ensure([], () => r(require('./components/template-4')), 'test'),
},
{
    path: '/middlePage',
    name: 'middlePage',
    component: middlePage,
},
];


const router = new VueRouter({
    mode: 'history',
    routes
});
//url 转对象
function urlToObject(url) {     var urlObject = {};     if (/\?/.test(url)) {       var urlString = url.substring(url.indexOf("?")+1);       var urlArray = urlString.split("&");       for (var i=0, len=urlArray.length; i<len; i++) {         var urlItem = urlArray[i];         var item = urlItem.split("=");         urlObject[item[0]] = item[1];       }       return urlObject;     }   };
// 对象转url
function convertObj(data) {
    var _result = [];
    for (var key in data) {
        var value = data[key];
        if (value.constructor == Array) {
            value.forEach(function(_value) {
                _result.push(key + "=" + _value);
            });
        } else {
            _result.push(key + '=' + value);
        }
    }
    return _result.join('&');
}
function removeOrganization() {
    localStorage.removeItem("third_partner_token");
    localStorage.removeItem("is_bind_third_user");
    localStorage.removeItem("third_partner_name");
    localStorage.removeItem("isElectron");
    localStorage.removeItem("common_org_code");
    localStorage.removeItem("common_logo");
    localStorage.removeItem("common_favicon");
    localStorage.removeItem("common_page_title");
    localStorage.removeItem("common_system_sort_name");
    localStorage.removeItem("common_home_url");
    localStorage.removeItem("flydata_data_teacher");
    localStorage.removeItem("flydata_data_student");
    localStorage.removeItem("flydata_data_teacher_type");
    sessionStorage.removeItem("pageCount");
    VueCookies.remove("is_electron_first");
    VueCookies.remove("paid_modal_visible");
    VueCookies.remove("class_id");
}
//刷新
function refresh() {
    fetch('/static_update/json/update.json?v=' + new Date().getTime().toString(), {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            "Authorization": "Bearer " + localStorage.getItem("access_token"),
        }
    })
        .then(function (response) {
            if (response.status == 200) {
                return response.json();
            } else {
                return Promise.reject(Response.statusText);
            }
        }).then(function (json) {
            let new_data = json.update_data;
            let old_data = localStorage.getItem('update_version') || ''
            if (new_data != old_data) {
                console.log("版本刷新了");
                localStorage.setItem("update_version", new_data);
                window.location.reload();
            }
        }).catch(function (ex) {
            // Toast.hide();
        })
}

//url获取参数
function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
            return pair[1];
        }
    }
    return (false);
}



//router变化时钩子
router.beforeEach((to, from, next) => {
    try {
        const loginArr = ["login", "electronLogin", "jpLogin", "register", "forget-password", "ground", "register-login", "error","wwxAuthSuccess"];
        if (loginArr.includes(to.name)) {
            console.log("清除第三方渠道信息");
            localStorage.removeItem("publicChannel");
            localStorage.removeItem("publicClientChannel");
        }
    } catch (err) {
        console.log(err)
    }

    const jpPageNotIntercept = [
        "register",
        "forget-password",
        "ground",
        "register-login"
    ]
    var url = window.location.href;
    // 区分爱米和jp登录页
    if (to.name == "login" && (url.indexOf('jp.akadm.com') > 0 || url.indexOf('fh.akadm.com') > 0)) {
        router.replace({
            name: "jpLogin"
        });
    } else if (to.name == "jpLogin" && (url.indexOf('jp.akadm.com') == -1 && url.indexOf('fh.akadm.com') == -1)) {
        router.replace({
            name: "login"
        });
    }

    // jp新增页面无需拦截
    if (window.location.href.indexOf('jp.akadm.com') > -1 || window.location.href.indexOf('fh.akadm.com') > -1|| window.location.href.indexOf('sso-register')>'-1') {
        if (jpPageNotIntercept.find(e => e == to.name)) {
            next();
            return
        }
    } else {
        // 爱米重定向
        if (jpPageNotIntercept.find(e => e == to.name)) {
            router.replace({
                name: "*"
            });
            return
        }
    }
    if ((to.name == "jpLogin" || to.name == "login") && VueCookies.get("class_id")) {
        // if ((to.name == "jpLogin" || to.name == "login" || to.name == "electronLogin") && VueCookies.get("class_id")) {
        if (VueCookies.get("user_type") == 2) {
            console.log("学生");
            sessionStorage.removeItem('cuerrent_subject_index');
            sessionStorage.removeItem('cuerrent_grade_index');
            sessionStorage.removeItem('cuerrent_section_index');
            router.replace({
                name: "student-index"
            });
        } else {
            console.log("老师");
            // let test_str= 'https://test-akdm4.akadm.com/login?access_token=K5Gj2hjs2546Hef&from=400&back_url=https%3A%2F%2Fwww.baidu.com&user_type_id=1&user_id=10495 ';
            let test_arr = urlToObject(window.location.href);
            console.log(test_arr)
        // && (test_arr.user_id && test_arr.user_id!=VueCookies.get("user_id"))
        //     if(window.location.href.indexOf('from') > -1 && to.query.from!=500){
            if(window.location.href.indexOf('from') > -1){
                if(to.query.from==500){
                    next();
                    return;
                }
                test_arr.partner_name = localStorage.getItem('third_partner_name')||test_arr.partner_name
                // let test_str= 'https://test-akdm4.akadm.com/login?access_token=K5Gj2hjs2546Hef&from=400&back_url=https%3A%2F%2Fwww.baidu.com&user_type_id=1&user_id=10495 ';
                logoutApi()
                    .then((res) => {
                        if (res.errCode == 0) {
                            removeOrganization();
                            VueCookies.set("user_id", test_arr.user_id);
                            router.replace({
                                name: "login",
                                query:test_arr
                            });
                            // router.replace({
                            //     name: "index"
                            // });

                        } else {
                            removeOrganization();
                            VueCookies.set("user_id", test_arr.user_id);
                            router.replace({
                                name: "login",
                                query:test_arr
                            });
                            // window.location.href = window.location.href ;
                            // router.replace({
                            //     name: "index"
                            // });
                        }
                    })
                    .catch((err) => {
                        throw new Error(err);
                    });
                return;
            }
            router.replace({
                name: "index"
            });
        }
        console.log(window.history);
        return;
    }
    if (getQueryVariable('code') && window.location.hostname != getQueryVariable('domain') && (to.name == 'login' || to.name == 'personal-center')) {
        router.replace({
            name: "middlePage",
            query: {
                domain: getQueryVariable('domain'),
                code: getQueryVariable('code'),
                state: getQueryVariable('state'),
                path: to.name
            }
        });
        return;
    }
    next();
    Vue.prototype.$flydata.flydataInit(to);
    refresh();
})
/* 路由异常错误处理，尝试解析一个异步组件时发生错误，重新渲染目标页面 */
router.onError((error) => {
    const pattern = /Loading chunk .+\S\s*failed/gi;
    const ischunkloadfailed = error.message.match(pattern);
    const targetPath = router.history.pending.fullPath;
    if (ischunkloadfailed) {
        router.go(0);
    }
});

export default router;
